<div id="bootstrap-overrides" class="fe_container">
    <div class="sub-container fe_header">
        <h2 class="headline-highlight">File Export</h2>
        <i class="fas fa-times close-icon" style="cursor: pointer;" id="fileclose" (click)="onDecline()">
          <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 6L18 18M6 18L18 6"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        </i>
    </div>
    <div class="loading-container" *ngIf="loading">
      <div class="loading">
        <div class="spinner-border" role="status">
          <span class="sr-only"></span>
        </div>
      </div>
    </div>
    
    <div class="" >

      <div class="fe_subheader mb-20" *ngIf="!loading"> <label>Select a file type:</label></div>
      <div style="display:inline-flex;gap:12px;margin-bottom:-22px" *ngIf="!loading">
      <div class="icondiv  mat-elevation-z8 highlight" id="dv_excel" (click)="setfiletype('excel')">
        <span ><img  src="../../../../assets/icons/excel_logo.png" style="padding-right:8px"/>Excel File</span>
      </div>
      <div class="icondiv mat-elevation-z8" id="dv_pdf" (click)="setfiletype('pdf')">
        <span ><img src="../../../../assets/icons/pdf_logo.png" style="padding-right:8px"/>PDF File</span>
      </div>
    </div>
    <div class="fe_para mt-20" *ngIf="!loading">
      <p>
        You can find your download file on a PC by pressing Ctrl + J (of Shift + ⌘ + J on a Mac). Please don’t close this window until the download is complete.
      </p>
    </div>
    <div class="fe_para mt-20"  style="text-align: center;" *ngIf="loading">
      <p>
        We are compiling your file.Do not close your browser.
      </p>
    </div>
    </div>
    <div *ngIf="!loading">
      <div class="btn p0">
                  <button class="cbutton" (click)="onDecline()"><img src="../../../../assets/icons/Vector.svg"/><label class="ctxt">Cancel</label></button>
      </div> 
      <div class="btn p0">
        <button class="dbutton" (click)="onAccept()"><label class="btext">Download File</label> <img src="../../../../assets/icons/Vector_black.svg"/></button>
      </div> 
  </div>
  <div class="fe_para clred" *ngIf="errorMessage!=''">
    <span>
      {{errorMessage}}
    </span>
  </div>

  </div>
      
